// extracted by mini-css-extract-plugin
export default {"logo":"FooterLogo_logo__3X1c5","logo__img":"FooterLogo_logo__img__CKlV1"};